export class GetOriginsInput {
  origin: string;

  constructor(origin?: string) {
    this.origin = origin;
  }
}
